import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/cash_flow/bags_cash_report/currencies";

export class GetBagsCashReportAvailableCurrenciesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<string[]> {
        var res = await this.executeCommand();
        if (res != null && res.data != null && res.data.Payload != null && res.data.Payload.Currencies != null && res.data.Payload.Currencies.length > 0)
            return res.data.Payload.Currencies;
        else return [];
    }
}
